import useContainerSize from '../../hooks/useContainerSize';
import LineGraph from '../home/graphLine';
import tailwindConfig from '../../../tailwind.config';
import { CategoricalData } from '../../api-models/types.gen';

interface GraphContainerProps {
  graphData: CategoricalData[] | undefined;
}

export default function GraphContainer({ graphData }: GraphContainerProps) {
  const [containerRef, { width, height }] = useContainerSize<HTMLDivElement>();
  return (
    <div ref={containerRef} className="h-full">
      {graphData
        ? (width > 0 && height > 0 && (
        <LineGraph
          graphData={graphData}
          showAxis
          gradient
          responsive={false}
          height={height}
          width={width}
          colour={tailwindConfig.theme.extend.colors.primary.DEFAULT}
          showGridlines
        />
        ))
        : <span className="flex h-full items-center justify-center text-sm text-secondary">Loading...</span>}
    </div>

  );
}
